import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { DataService } from '../../services/data.service';
@Component({
  selector: 'app-modal-foto',
  templateUrl: './modal-foto.component.html',
  styleUrls: ['./modal-foto.component.css']
})
export class ModalFotoComponent {
  WIDTH = 500;
  HEIGHT = 280;
  captured: any;
  error: any;
  isCaptured: boolean = false;
  fileCaptured: any;
  exceededMaxFileSize: boolean = false;
  @ViewChild("video", { static: true }) public video!: ElementRef;
  @ViewChild("canvas", { static: true }) public canvas!: ElementRef;
  constructor(public activeModal: NgbActiveModal, public dataService: DataService) { }
  async ngAfterViewInit() {
    await this.setupDevices();
  }
  async setupDevices() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });
        if (stream) {
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
          this.error = null;
        } else {
          this.error = "You have no output video device";
        }
      } catch (e) {
        this.error = e;
      }
    }
  }
  capture() {
    this.drawImageToCanvas(this.video.nativeElement);
    this.fileCaptured = this.canvas.nativeElement.toDataURL("image/png", 0);
    this.captured = {
      file: this.canvas.nativeElement.toDataURL("image/png", 0).toString().split(",")[1],
      contentType: "image/png",
      fileName: "Foto.png",
      size: 140000 / 1024
    };
    //this.captures = captureUser;
    this.isCaptured = true;
    Swal.fire({
      imageUrl: this.fileCaptured,
      imageAlt: 'Custom image',
      confirmButtonColor: 'var(--cor-verde-pure)',
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: 'var(--cor-vermelha-pure)',
      showCancelButton: true,
      padding: '24px',
      text: "Deseja incluir essa foto?",
    }).then((result) => {
      if (!result.dismiss) {
        Swal.fire(
          'Foto anexada com Sucesso!',
          '',
          'success',
        )
        this.activeModal.close(this.captured)
      }
    })
  }
  resizeImage(img: any, w: any, h: any) {
    var result = new Image();
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    canvas.getContext('2d')?.drawImage(img, 0, 0, w, h);
    result.src = canvas.toDataURL();
    return result;
  }
  convertDataURIToBinary(dataURI: any) {
    var base64Index = dataURI.indexOf(';base64,') + ';base64,'.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));
    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }
  drawImageToCanvas(image: any) {
    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }
}
const toBase64 = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
const toByteArray = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
  reader.onerror = error => reject(error);
});